import { render } from "./form5.vue?vue&type=template&id=45475526&scoped=true"
import script from "./form5.vue?vue&type=script&lang=js"
export * from "./form5.vue?vue&type=script&lang=js"

import "./form5.vue?vue&type=style&index=0&id=45475526&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45475526"]])

export default __exports__